@if (item) {
  <span class="item">
    @if (item.routerLink) {
      <a [routerLink]="[item!.routerLink]">
        <span class="icon" [ngClass]="item!.icon || ''"></span>
      </a>
    }
    @if (item.command) {
      <a (click)="selected(item!)">
        <span class="icon" [ngClass]="item!.icon || ''"></span>
      </a>
    }
  </span>
}
